import { useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";

export default function ServicesTab({ services, reload }) {
  const [edits, setEdits] = useState({});

  const field = (slug, key, val) =>
    setEdits((cur) => ({ ...cur, [slug]: { ...(cur[slug] || {}), [key]: val } }));

  const save = async (s) => {
    const body = edits[s.slug] || {};
    if (body.includes_list && typeof body.includes_list === "string")
      body.includes_list = body.includes_list.split("\n").map((x) => x.trim()).filter(Boolean);
    try {
      await api.put(`/admin/services/${s.slug}`, body);
      toast.success(`${s.name} updated`);
      setEdits((cur) => ({ ...cur, [s.slug]: undefined }));
      reload();
    } catch (err) {
      toast.error(apiError(err));
    }
  };

  const input = "w-full bg-[#070b12] border border-white/15 rounded-xl px-4 py-2.5 text-sm text-white focus:border-[#1e9bff] outline-none";

  return (
    <div className="space-y-6" data-testid="services-tab">
      {services.map((s) => {
        const e = edits[s.slug] || {};
        const dirty = Object.keys(e).length > 0;
        return (
          <article key={s.slug} className="p-5 rounded-2xl bg-[#0b1322] border border-[#1e9bff]/20 space-y-3" data-testid={`service-edit-${s.slug}`}>
            <h3 className="font-display uppercase text-lg text-white">{s.name}</h3>
            <div>
              <label className="text-[10px] font-mono-lbl uppercase tracking-widest text-[#1e9bff] block mb-1">Tagline (card)</label>
              <input className={input} value={e.tagline ?? s.tagline} data-testid={`service-tagline-${s.slug}`}
                onChange={(ev) => field(s.slug, "tagline", ev.target.value)} />
            </div>
            <div>
              <label className="text-[10px] font-mono-lbl uppercase tracking-widest text-[#1e9bff] block mb-1">Includes (card)</label>
              <input className={input} value={e.includes ?? s.includes} data-testid={`service-includes-${s.slug}`}
                onChange={(ev) => field(s.slug, "includes", ev.target.value)} />
            </div>
            <div>
              <label className="text-[10px] font-mono-lbl uppercase tracking-widest text-[#1e9bff] block mb-1">Description (service page)</label>
              <textarea rows={3} className={input} value={e.description ?? s.description} data-testid={`service-description-${s.slug}`}
                onChange={(ev) => field(s.slug, "description", ev.target.value)} />
            </div>
            <div>
              <label className="text-[10px] font-mono-lbl uppercase tracking-widest text-[#1e9bff] block mb-1">What's included — one per line (service page)</label>
              <textarea rows={4} className={input} value={e.includes_list ?? (s.includes_list || []).join("\n")} data-testid={`service-list-${s.slug}`}
                onChange={(ev) => field(s.slug, "includes_list", ev.target.value)} />
            </div>
            <button onClick={() => save(s)} disabled={!dirty} data-testid={`service-save-${s.slug}`}
              className="px-6 py-2.5 rounded-xl bg-[#1e9bff] text-black text-xs font-bold uppercase tracking-wider hover:bg-[#60baff] transition-colors disabled:opacity-40">
              Save Changes
            </button>
          </article>
        );
      })}
    </div>
  );
}
